import React from "react";
import {
  TeamOutlined,
  CrownOutlined,
  ApartmentOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import styles from "./services.module.scss";

const services = [
  {
    icon: <TeamOutlined />,
    title: "Talent Acquisition",
    description:
      "We deliver end-to-end recruitment solutions focused on sourcing, evaluating, and onboarding high-quality talent aligned with your business objectives.",
  },
  {
    icon: <CrownOutlined />,
    title: "Leadership & Executive Hiring",
    description:
      "Specialized executive search services to identify leaders who bring strategic vision, cultural alignment, and long-term value to organizations.",
  },
  {
    icon: <ApartmentOutlined />,
    title: "Bulk & Lateral Hiring",
    description:
      "Efficient hiring models designed for scale, ensuring speed, quality, and consistency across bulk and lateral recruitment requirements.",
  },
  {
    icon: <BarChartOutlined />,
    title: "HR Advisory & Consulting",
    description:
      "Strategic HR consulting to enhance workforce planning, talent assessment, and organizational effectiveness for sustainable growth.",
  },
];

const ServicesPage = () => {
  return (
    <section className={styles.services}>
      <div className={styles.header}>
        <h2>Our Services</h2>
        <p>
          Purpose-driven recruitment and HR solutions crafted to help
          organizations build resilient, future-ready teams.
        </p>
      </div>

      <div className={styles.grid}>
        {services.map((service, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.icon}>{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesPage;
